var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 4.94118,
    fill: "#EFFBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5376 27.592C23.4312 28.5 21.7875 28.5 18.5 28.5C15.2125 28.5 13.5688 28.5 12.4624 27.592C12.2599 27.4258 12.0742 27.2401 11.908 27.0376C11 25.9312 11 24.2875 11 21C11 17.7125 11 16.0688 11.908 14.9624C12.0742 14.7599 12.2599 14.5742 12.4624 14.408C13.5688 13.5 15.2125 13.5 18.5 13.5C21.7875 13.5 23.4312 13.5 24.5376 14.408C24.7401 14.5742 24.9258 14.7599 25.092 14.9624C26 16.0688 26 17.7125 26 21C26 24.2875 26 25.9312 25.092 27.0376C24.9258 27.2401 24.7401 27.4258 24.5376 27.592Z",
    stroke: "#00BACB",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 22V20L28.6 16.5333C28.8518 16.1976 29.247 16 29.6667 16C30.403 16 31 16.597 31 17.3333V24.6667C31 25.403 30.403 26 29.6667 26C29.247 26 28.8518 25.8024 28.6 25.4667L26 22Z",
    stroke: "#00BACB",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 20C19.0523 20 19.5 20.4477 19.5 21C19.5 21.5523 19.0523 22 18.5 22C17.9477 22 17.5 21.5523 17.5 21C17.5 20.4477 17.9477 20 18.5 20Z",
    stroke: "#00BACB",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoicon);
export default __webpack_public_path__ + "static/media/video icon.8f7f666e42cee4bd151d9748669e10e9.svg";
export { ForwardRef as ReactComponent };